import React, { useEffect, useState } from "react";
import { isSha1 } from "helpers/fileHelpers";
import ImageRenderer from "./ImageRenderer";
import apiCall from "services/apiCall";
import { getFileDetails } from "services/file-service";
import { useDispatch, useSelector } from "react-redux";
import { addAws, getAwsImage } from "store/slices/awsSlice";

const AwsImage = ({ sha1, className, thumb }) => {
  const awsHashes = useSelector(getAwsImage);
  const dispatch = useDispatch(addAws);
  const [imageUri, setImageUri] = useState("");

  useEffect(() => {
    if (sha1) {
      getImage();
    }
  }, [sha1]);

  const getImgUri = () => {
    const onSuccess = (response) => {
      if (response?.data?.length > 0) {
        dispatch(
          addAws({
            sha1: sha1,
            url: response?.data,
            timestamp: new Date().getTime()
          })
        );
      }
      setImageUri(response.data);
    };
    apiCall({
      service: getFileDetails,
      serviceParams: sha1,
      onSuccess: onSuccess
    });
  };

  const getImage = async () => {
    if (awsHashes[sha1]?.url && new Date().getTime() - awsHashes[sha1]?.timestamp < 600000) {
      //600000 ms -> 10 mn
      setImageUri(awsHashes[sha1].url);
    } else {
      if (typeof sha1 !== "undefined" && sha1 !== null && sha1.startsWith("http")) {
        setImageUri(sha1);
      } else if (typeof sha1 !== "undefined" && isSha1(sha1)) {
        getImgUri();
      }
    }
  };

  // const onError = (err) => {
  //   if (sha1) storeToRedux(sha1);
  // };

  return (
    <ImageRenderer
      url={imageUri}
      thumb={thumb}
      alt={sha1}
      className={className}
      // onError={onError}
    />
  );
};

export default AwsImage;
